export default __webpack_public_path__ + "static/media/888.6b09bcd1.PNG";